import React from 'react';
import { LandingPage } from './components/LandingPage';
function App() {
  return <LandingPage data-id="element-0" />;
}
export { App };